"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
/**
 * Returns a promise that yields `value` after a delay.
 *
 * @param ms The delay in milliseconds.
 * @param value The result value.
 */
function delay(ms, value) {
    return new Promise(function (resolve) {
        setTimeout(function () { return resolve(value); }, ms);
    });
}
exports.delay = delay;
//# sourceMappingURL=delay.js.map